module.exports = __webpack_public_path__ + "img/dclean.06c3ea75.png";